import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class importacionServicioService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/importacion-servicio`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


}

export default new importacionServicioService();